export default {
  firstname: "",
  lastname: "",
  civicRegistrationNumber: "",
  email: "",
  zipCode: "",
  cellPhone: ""
};
